import * as Yup from 'yup';
import qualifications from 'utils/qualifications';
import { DB_PREFIX_JOBS, DB_PREFIX_QUALIFICATIONS } from './constants';

const q = qualifications.reduce((acc, { name }) => {
  return {
    ...acc,
    ...{
      [name]: Yup.object()
        .shape({
          level: Yup.string().nullable().required('Level Required'),
          fileURL: Yup.string().nullable(),
        })
        .nullable(),
    },
  };
}, {});

export default Yup.object().shape({
  [DB_PREFIX_QUALIFICATIONS]: Yup.object().shape({ ...q }),

  [DB_PREFIX_JOBS]: Yup.array().of(
    Yup.object().shape({
      sector: Yup.string().required('Required').nullable(),
      role: Yup.string().required('Required').nullable(),
    })
  ),
});
